import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from '@heroicons/react/24/outline';
import './Cosection1.css';
import questionn from "../assets/images/krinvy_getintouch.png"; // Example new image

const Cosection1 = ({ setShowOutsourceModal }) => {
  return (
    <div className="contactt-container">
      <div>
        <img src={questionn} alt="Connect with Krinvy" className="img-question" />
      </div>
      <div className="contact-content">
        <h2>Have Questions? We're here to help.</h2>
        <p className="ppp-question">Our team is ready to provide clarity and solutions tailored to your needs</p>

        <div className="contact-buttons">
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="contact-btn get-started-btn"
            onClick={() => setShowOutsourceModal(true)}
          >
            <span>Contact Our Team</span>
            <ArrowRightIcon className="w-5 h-5 ml-2" />
          </motion.button>
        </div>
      </div>
    </div>
  );
};

export default Cosection1;
